import { render, staticRenderFns } from "./Studies.vue?vue&type=template&id=3f380392&"
import script from "./Studies.vue?vue&type=script&lang=js&"
export * from "./Studies.vue?vue&type=script&lang=js&"
import style0 from "./Studies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports